'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _Logs = require('../../helpers/Logs');

var _HintPopup = require('./HintPopup.scss');

var _HintPopup2 = _interopRequireDefault(_HintPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HintPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    log: state.log };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(HintPopup, _Component);

  function HintPopup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HintPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HintPopup.__proto__ || (0, _getPrototypeOf2.default)(HintPopup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showHint: false
    }, _this.onHint = function () {
      var source = void 0;
      var destination = void 0;
      if (_this.state.showHint) {
        source = _this.props.navigationLog;
        destination = _this.props.log.src;
      } else {
        source = _this.props.log.src;
        destination = _this.props.navigationLog;
      }
      (0, _Logs.logNavigationPopup)(source, destination, _this.props.log, _this.props.auth, _this.props.appInfo);
      _this.setState({ showHint: !_this.state.showHint });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HintPopup, [{
    key: 'render',
    value: function render() {
      var className = _HintPopup2.default.hintPopupContent + (this.props.className ? ' ' + this.props.className : '');
      var showHint = this.state.showHint;

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: _HintPopup2.default.hintPopup, onClick: this.onHint },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, this.props.text)
        ),
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 'hint-popup-login-transition',
            transitionEnterTimeout: 500,
            transitionLeaveTimeout: 500
          },
          showHint ? _react2.default.createElement(
            'div',
            { key: 'openHint', className: _HintPopup2.default.popupContent },
            _react2.default.createElement('div', { className: _HintPopup2.default.overlay, onClick: this.onHint }),
            _react2.default.createElement(
              'div',
              { className: _HintPopup2.default.messageContent },
              _react2.default.createElement(
                'div',
                { className: _HintPopup2.default.messages },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, this.props.hintText, {
                  values: { value: this.props.hintTextValue }
                }))
              )
            )
          ) : ''
        )
      );
    }
  }]);
  return HintPopup;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  className: _react.PropTypes.string.isRequired,
  hintText: _react.PropTypes.object.isRequired,
  hintTextValue: _react.PropTypes.string,
  log: _react.PropTypes.object,
  navigationLog: _react.PropTypes.string.isRequired,
  text: _react.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = HintPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HintPopup/HintPopup.js
// module id = 1956
// module chunks = 0